import { render, staticRenderFns } from "./ICApproveLevel2.vue?vue&type=template&id=84434e5a"
import script from "./ICApproveLevel2.vue?vue&type=script&lang=js"
export * from "./ICApproveLevel2.vue?vue&type=script&lang=js"
import style0 from "./ICApproveLevel2.vue?vue&type=style&index=0&id=84434e5a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports